import { render, staticRenderFns } from "./labelmanage.vue?vue&type=template&id=9f4a9aa0&scoped=true&"
import script from "./labelmanage.vue?vue&type=script&lang=js&"
export * from "./labelmanage.vue?vue&type=script&lang=js&"
import style0 from "./labelmanage.vue?vue&type=style&index=0&id=9f4a9aa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4a9aa0",
  null
  
)

export default component.exports